module.exports = __webpack_public_path__ + "media/images/c-fileUploader/icon-c3b4ac79b0a311a489f3d97ccfb25dd5.svg";